import { render, staticRenderFns } from "./GrossProfitPSDialog.vue?vue&type=template&id=2d17a4fc&scoped=true"
import script from "./GrossProfitPSDialog.vue?vue&type=script&lang=js"
export * from "./GrossProfitPSDialog.vue?vue&type=script&lang=js"
import style0 from "./GrossProfitPSDialog.vue?vue&type=style&index=0&id=2d17a4fc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d17a4fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d17a4fc')) {
      api.createRecord('2d17a4fc', component.options)
    } else {
      api.reload('2d17a4fc', component.options)
    }
    module.hot.accept("./GrossProfitPSDialog.vue?vue&type=template&id=2d17a4fc&scoped=true", function () {
      api.rerender('2d17a4fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/components/GrossProfitPSDialog.vue"
export default component.exports